/**
 * Register the PWA service worker (/sw.js).
 *
 * Only runs in production builds on secure contexts — CRA's dev server would
 * fight with it, and browsers refuse SW registration off HTTPS/localhost anyway.
 */
export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator) || !window.isSecureContext) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // Check for an updated SW on each full page load
        registration.update().catch(() => {});
      })
      .catch((err) => {
        console.error('Service worker registration failed:', err);
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => {});
  }
}
